import GetMerchantInfoSymbols from '../symbols/getMerchantInfo';
import { HttpRequestGet } from "../../service";
const getMerchantInfoAction = () => ({
  type: GetMerchantInfoSymbols.GET_MERCHANT_INFO,
});
const getMerchantInfoSuccessAction = (data: any) => ({
  type: GetMerchantInfoSymbols.GET_MERCHANT_INFO_SUCCESS,
  payload: data,
});
const getMerchantInfoFailureAction = (data: any) => ({
  type: GetMerchantInfoSymbols.GET_MERCHANT_INFO_FAILURE,
  payload: data,
});
const cleargetMerchantInfoAction = () => ({
  type: GetMerchantInfoSymbols.CLEAR_GET_MERCHANT_INFO,
});
export function getMerchantInfo(shopId: string | null, callback?: Function) {
  let url = `/admin/shop/${shopId}`;
  return (dispatch: any) => {
    dispatch(getMerchantInfoAction());
    HttpRequestGet(
      url,
      dispatch,
      getMerchantInfoSuccessAction,
      getMerchantInfoFailureAction,
      true,
      callback
    );
  };
}

export function clearMerchantInfo() {
  return (dispatch: any) => {
    dispatch(cleargetMerchantInfoAction());
  };
}
